import type Setting from '@/types/Setting'

/**
 * Lists every available setting with the owner's value, falling back to the
 * setting's default when the owner hasn't customized it.
 */
export function resolveSettings(available: Setting[], current: Setting[] | undefined): Setting[] {
  return available.map(setting => ({
    ...setting,
    value: current?.find(s => s.id === setting.id)?.value ?? setting.default,
  }))
}
